export default __webpack_public_path__ + "media/theatre-class-lecture-29730.be6a72c3.mp3";